import img1 from '../images/post/post_1.jpg';
import img2 from '../images/post/post_2.jpg';
import img3 from '../images/post/post_3.jpg';

const dataBlog = [
    {
        id: 1,
        img: img1,
        heading: 'The Future of Virtual Reality',
        cate: 'Virtual Reality',
        text: 'Exploring the advancements and future potential of virtual reality technology.',
        date: '2023-10-01',
        authors: ['John Doe', 'Jane Smith'],
        tags: ['VR', 'Technology', 'Future'],
        content: [
            {
                type: 'subtitle',
                value: 'Advancements in VR Technology'
            },
            {
                type: 'video',
                value: 'https://www.youtube.com/embed/xyz123'
            },
            {
                type: 'image',
                value: img1
            },
            {
                type: 'paragraph',
                value: 'Virtual reality (VR) has come a long way since its inception. With advancements in technology, VR is becoming more immersive and accessible. In this blog post, we explore the future potential of VR and how it can revolutionize various industries.'
            }
        ]
    },
    {
        id: 2,
        img: img2,
        heading: 'Augmented Reality vs Virtual Reality',
        cate: 'Augmented Reality',
        text: 'Understanding the differences and similarities between augmented reality (AR) and virtual reality (VR).',
        date: '2023-10-02',
        authors: ['Alice Johnson', 'Bob Brown'],
        tags: ['AR', 'VR', 'Comparison'],
        content: [
            {
                type: 'subtitle',
                value: 'Key Differences and Similarities'
            },
            {
                type: 'video',
                value: 'https://www.youtube.com/embed/abc456'
            },
            {
                type: 'image',
                value: img2
            },
            {
                type: 'paragraph',
                value: 'While both augmented reality (AR) and virtual reality (VR) offer immersive experiences, they are fundamentally different technologies. AR overlays digital content onto the real world, whereas VR creates a completely virtual environment. This blog post delves into the key differences and similarities between AR and VR.'
            }
        ]
    },
    {
        id: 3,
        img: img3,
        heading: 'The Rise of the Metaverse',
        cate: 'Metaverse',
        text: 'Exploring the concept of the metaverse and its potential impact on society.',
        date: '2023-10-03',
        authors: ['Charlie Davis', 'Dana Lee'],
        tags: ['Metaverse', 'Digital', 'Society'],
        content: [
            {
                type: 'subtitle',
                value: 'A New Digital Frontier'
            },
            {
                type: 'video',
                value: 'https://www.youtube.com/embed/def789'
            },
            {
                type: 'image',
                value: img3
            },
            {
                type: 'paragraph',
                value: 'The metaverse is a collective virtual shared space, created by the convergence of virtually enhanced physical reality and physically persistent virtual space. It is a new digital frontier that has the potential to transform how we interact, work, and play. In this blog post, we explore the rise of the metaverse and its potential impact on society.'
            }
        ]
    }
]

export default dataBlog;